import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Modal, ModalBody, Accordion, OverlayTrigger, Tooltip} from "react-bootstrap";
import { FaSearch, FaEraser } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, formataDataHoraExibicao, getCurrentUser, tiposAcesso, formataCNPJ } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import moment from 'moment-timezone';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

class ExtratoServicos extends Component {
    constructor(props) {
        super(props);
        this.handleChangeFiltros = this.handleChangeFiltros.bind(this);
        this.handleTogglePago = this.handleTogglePago.bind(this);
        

        this.state = {
            listRegistros: [],
            error: "",
            loading: false,
            totalPeriodo: 0,
            filtro_data_inicio: '',
            filtro_data_fim: '',
            filtro_cliente_id: '',
            filtro_cliente_nome: '',
            filtro_programa_id: '',
            filtro_programa_nome: '',
            filtro_prestador_id: '',
            filtro_prestador_nome: '',
            filtro_nota_fiscal: '',
            filtro_a_faturar: true,
            showModal: false,
            modalData: '',
            modalLink: '',
            checkTodos: false,
            listSelecionados: {},
            programa_select_key: 0,
            prestador_select_key: 0,
            atendimentos_desabilitados: [],
            permite_editar: true,
            filtro_doenca_id: '',
            filtro_doenca_nome: '',
            doenca_select_key: 0,
            programaConfig: {},
        };
    }

    componentDidMount(){
        let startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
        let endOfMonth   = moment().endOf('month').format('YYYY-MM-DD');

        let dados_usuario = getCurrentUser();
        const cliente_id = (dados_usuario['ambiente_cliente_id']) ? dados_usuario['ambiente_cliente_id'] : '';
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : '';

        this.setState({
            filtro_data_inicio: startOfMonth,
            filtro_data_fim: endOfMonth,
            filtro_cliente_id: cliente_id,
            filtro_programa_id: programa_id,
            filtro_prestador_id: '',
            filtro_nota_fiscal: '',
        }, () => {
			if (programa_id) {
				this.buscarConfiguracaoPrograma(programa_id);
			}
            //this.consultaRegistro()
        });
    }

    getSelecionadosGrupo = (prestadorId) => {
        const key = String(prestadorId);
        return this.state.listSelecionados[key] || [];
    };

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'cliente_id') {
            this.setState(prevState => ({
                filtro_cliente_id: event.value, 
                filtro_cliente_nome: event.label,
                filtro_programa_id: "", 
                filtro_programa_nome: "",
                programa_select_key: prevState.programa_select_key + 1,
                listSelecionados: [],
                filtro_doenca_id: "", 
                filtro_doenca_nome: "",
                doenca_select_key: prevState.doenca_select_key + 1,
            }));
        }
        else if(fieldName == 'programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label, 
                filtro_prestador_id: "", 
                filtro_prestador_nome: "", 
                prestador_select_key: prevState.prestador_select_key + 1,
                listSelecionados: [],
                filtro_doenca_id: "", 
                filtro_doenca_nome: "",
                prestador_select_key: prevState.prestador_select_key + 1,
                doenca_select_key: prevState.prestador_select_key + 1 
            }), () => {
				this.buscarConfiguracaoPrograma(event.value);
			});
        }
        else if(fieldName == 'prestador_id') {
            this.setState({ 
                filtro_prestador_id: event.value, 
                filtro_prestador_nome: event.label, 
                listSelecionados: []
            }, () => {
                this.consultaRegistro()
            });
        }
        else if(fieldName == 'doenca_id') {
            this.setState({ 
                filtro_doenca_id: event.value, 
                filtro_doenca_nome: event.label, 
            });
        }
        else if(fieldName == 'a_faturar'){
            this.setState({
                filtro_a_faturar: event.target.checked,
            })
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    desabilitaAtendimentos = () => {
        let lista = [];

        // listRegistros agora é um objeto com chaves = id do prestador
        // ex: { "583": { prestador: {...}, itens: [...] }, ... }
        const grupos = this.state.listRegistros
            ? (Array.isArray(this.state.listRegistros)
                ? this.state.listRegistros
                : Object.values(this.state.listRegistros))
            : [];

        grupos.forEach(grupo => {
            (grupo.itens || []).forEach(registro => {
                const df = registro.dados_faturamento || {};

                // se já tiver faturamento (objeto com alguma chave)
                if (df && Object.keys(df).length > 0) {
                    lista.push(registro.id);
                }

                // se for crédito antecipado
                if (registro.credito_antecipado) {
                    lista.push(registro.id);
                }

                // se tiver campo nota em dados_faturamento
                if ('nota' in df) {
                    lista.push(registro.id);
                }

                // regra específica do programa Servier - IDHentifique
                if (
                    registro.dados_programa?.nome === 'Servier - IDHentifique' &&
                    registro.dados_atendimento?.etapa_nota_fiscal === false
                ) {
                    lista.push(registro.id);
                }

                //  valida configuração do programa para exigir resultado
                if (
                    this.state.programaConfig?.configuracoes?.extratos_servicos?.faturar_apenas_com_resultado_atrelado === true
                ) {
                    if (!registro.dados_formulario_aprovacao && !registro.dados_servico?.dados_formulario_aprovacao && registro.dados_servico?.ocultar_solicitacao_exames !== true) {
                        lista.push(registro.id);
                    }
                }
            });
        });

        // remove duplicados, só por garantia
        lista = [...new Set(lista)];

        this.setState(
            {
                atendimentos_desabilitados: lista,
            },
            () => {
                console.log(
                    'atendimentos_desabilitados: ',
                    this.state.atendimentos_desabilitados
                );
            }
        );
    };

    addItemLista = (prestadorId, itemId, marcado) => {
        const keyPrestador = String(prestadorId);
        const idStr = String(itemId);

        this.setState(prev => {
            const atuaisGrupo = prev.listSelecionados[keyPrestador] || [];
            let novosGrupo;

            if (marcado) {
                if (atuaisGrupo.includes(idStr)) {
                    return null; // nada muda
                }
                novosGrupo = [...atuaisGrupo, idStr];
            } else {
                novosGrupo = atuaisGrupo.filter(id => id !== idStr);
            }

            return {
                listSelecionados: {
                    ...prev.listSelecionados,
                    [keyPrestador]: novosGrupo,
                },
            };
        });
    };



	buscarConfiguracaoPrograma = (programa_id) => {
		api.get(`/programas/${programa_id}/`)
			.then(response => {
				this.setState({
					programaConfig: response.data,
				}, () => {
					this.desabilitaAtendimentos();
				});
			})
			.catch(error => {
				console.error("Erro ao buscar configuração do programa:", error);
			});
	}

    consultaRegistro(){        
        if (!this.state.filtro_programa_id) {
            this.setState({ loading: false });
            return;
        }

        let filtros = '?1=1';

        if(this.state.filtro_data_inicio){
            filtros += '&data_inicio='+this.state.filtro_data_inicio
        }

        if(this.state.filtro_data_fim){
            filtros += '&data_fim='+this.state.filtro_data_fim
        }

        if(this.state.filtro_cliente_id){
            filtros += '&cliente_id='+this.state.filtro_cliente_id
        }
        
        if(this.state.filtro_programa_id){
            filtros += '&programa_id='+this.state.filtro_programa_id
        }
         

        if(this.state.filtro_prestador_id){
            filtros += '&prestador_id='+this.state.filtro_prestador_id
        }

        if(this.state.filtro_doenca_id){
            filtros += '&doenca_id='+this.state.filtro_doenca_id;
        }

        if(this.state.filtro_a_faturar){
            filtros += '&a_faturar=1';
        }

        api.get('/extratoservicos/'+filtros)
        .then(response => {
            const dados = response.data;            
            const dados_agrupados = this.agruparPorPrestador(dados);

            this.setState({
                loading: false,
                error: "",
                listRegistros: dados_agrupados,
                listSelecionados: [],
                checkTodos: false
            }, () => {
                this.desabilitaAtendimentos()
            });

            //this.verificaBloqueioEdicao();
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar o extrato, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    openModal = (data, link) => {
        this.setState({
            showModal: true,
            modalData: data,
            modalLink: link
        });
    }

    closeModal = () => {
        this.setState({
            showModal: false,
            modalData: '',
            modalLink: ''
        });
    }

    verificaBloqueioEdicao = () => {
        const tipos_acesso = tiposAcesso();

        if ('gestor' in tipos_acesso) {
            if ('tipo_gestor' in tipos_acesso.gestor && tipos_acesso.gestor.tipo_gestor == 'industria') {
                this.setState({ permite_editar: false });            
            }            
        }
    }

    toggleGrupo = (grupo, marcado) => {
        const prestadorId = String(grupo.prestador.id);

        const idsSelecionaveisGrupo = grupo.itens
            .filter(item => !this.state.atendimentos_desabilitados.includes(item.id))
            .map(item => String(item.id));

        this.setState(prev => {
            const listSelecionados = { ...prev.listSelecionados };

            if (marcado) {
                // marca todos do grupo
                listSelecionados[prestadorId] = idsSelecionaveisGrupo;
            } else {
                // desmarca todos do grupo
                listSelecionados[prestadorId] = [];
            }

            return { listSelecionados };
        });
    };

    renderRows = () => {
        const { listRegistros } = this.state;

        // transforma o objeto em array de grupos
        const grupos = listRegistros ? Object.values(listRegistros) : [];

        if (!grupos.length) {
            return <></>;
        }

        return (
            <Accordion alwaysOpen>
                {grupos.map((grupo, index) => {                    
                    const prestadorId = grupo.prestador.id;
                    const selecionadosGrupo = this.getSelecionadosGrupo(prestadorId);
                    const grupoTemSelecionados = selecionadosGrupo.length > 0;

                    // ids "selecionáveis" (não desabilitados) desse grupo
                    const idsSelecionaveisGrupo = grupo.itens
                        .filter(item => !this.state.atendimentos_desabilitados.includes(item.id))
                        .map(item => String(item.id));

                    const grupoTodosSelecionados =
                        idsSelecionaveisGrupo.length > 0 &&
                        idsSelecionaveisGrupo.every(id => selecionadosGrupo.includes(id));

                    return (
                        <Accordion.Item
                            eventKey={String(index)}
                            key={grupo.prestador.id}
                        >
                            <Accordion.Header>
                                {grupo.prestador.nome} (ID: {grupo.prestador.id}, CNPJ: {formataCNPJ(grupo.prestador.cpf_cnpj)}) 
                            </Accordion.Header>
                            <Accordion.Body>
                                {grupoTemSelecionados && (
                                    <div className="d-flex flex-row mb-3">
                                        <div className="pt-2 me-2">
                                            Com os selecionados:
                                        </div>
                                        <div>
                                            <Button
                                                type="button"
                                                className="btn btn-sm btn-success"
                                                disabled={this.state.loading}
                                                onClick={() =>
                                                    this.gerarFaturamento(
                                                        grupo.prestador.id
                                                    )
                                                }
                                            >
                                                {this.state.loading ? (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                ) : (
                                                    'Gerar faturamento'
                                                )}
                                            </Button>
                                        </div>
                                    </div>
                                )}

                                <Table striped bordered hover>
                                    <thead>
                                        <tr>
                                            <th>
                                                {this.state.permite_editar && (
                                                    <Form.Check
                                                        type="checkbox"
                                                        id={`check_grupo_${prestadorId}`}
                                                        disabled={idsSelecionaveisGrupo.length === 0}
                                                        checked={grupoTodosSelecionados}
                                                        onChange={e =>
                                                            this.toggleGrupo(grupo, e.target.checked)
                                                        }
                                                    />
                                                )}
                                            </th>
                                            <th>ID</th>
                                            <th>Data do Serviço</th>
                                            <th>Nota</th>
                                            <th>Pagamento</th>
                                            <th>Paciente</th>
                                            <th>Atendimento</th>
                                            <th>Cliente / Programa</th>
                                            {/*<th>Prestador</th>*/}
                                            <th>Serviço</th>
                                            <th>Valor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {grupo.itens.map((item, idx) => {
                                            const prestadorId = grupo.prestador.id;
                                            const selecionadosGrupo = this.getSelecionadosGrupo(prestadorId);
                                            const valor = item.valor || 0;                                            
                                            let nota_fiscal = '---';

                                            if (
                                                item.dados_faturamento &&
                                                item.dados_faturamento.nota
                                            ) {
                                                nota_fiscal = (
                                                    <a
                                                        className="btn btn-secondary btn-sm mt-2"
                                                        href={
                                                            item.dados_faturamento.nota
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        Ver nota
                                                    </a>
                                                );
                                            }

                                            return (
                                                <tr
                                                    key={`${grupo.prestador.id}-${item.id}`}
                                                >
                                                    <td>


                                                        {this.state.permite_editar && (
                                                            <>
                                                                {(() => {
                                                                    const programConfig = this.state.programaConfig?.configuracoes?.extratos_servicos?.faturar_apenas_com_resultado_atrelado;
                                                                    const bloqueadoPorResultado = programConfig === true && !item?.dados_formulario_aprovacao && !item.dados_servico?.dados_formulario_aprovacao && item.dados_servico?.ocultar_solicitacao_exames !== true;
                                                                    
                                                                    const checkbox = (
                                                                        <Form.Check
                                                                            type="checkbox"
                                                                            id={'check_filho_' + item.id}
                                                                            label=""
                                                                            value={item.id}
                                                                            disabled={this.state.atendimentos_desabilitados.includes(item.id)}
                                                                            checked={selecionadosGrupo.includes(String(item.id))}
                                                                            onChange={e =>
                                                                                this.addItemLista(
                                                                                    prestadorId,
                                                                                    item.id,
                                                                                    e.target.checked
                                                                                )
                                                                            }
                                                                        />
                                                                    );

                                                                    if (bloqueadoPorResultado) {
                                                                        return (
                                                                            <OverlayTrigger
                                                                                placement="right"
                                                                                overlay={
                                                                                    <Tooltip id={`tooltip-disabled-${item.id}`}>
                                                                                        Faturamento permitido apenas com resultado atrelado.
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <span className="d-inline-block">
                                                                                    {checkbox}
                                                                                </span>
                                                                            </OverlayTrigger>
                                                                        );
                                                                    }

                                                                    return checkbox;
                                                                })()}
                                                            </>
                                                        )}
                                                    </td>

                                                    <td>{item.id}</td>
                                                    <td>
                                                        {formataDataHoraExibicao(
                                                            item.data
                                                        )}
                                                    </td>
                                                    <td>{nota_fiscal}</td>
                                                    <td>
                                                        {item.credito_antecipado
                                                            ? 'Crédito Antecipado'
                                                            : item.dados_faturamento
                                                                ?.pago
                                                            ? 'Sim'
                                                            : 'Não'}
                                                        {item.dados_faturamento &&
                                                            item.dados_faturamento
                                                                .data_pagamento && (
                                                                <>
                                                                    <br />
                                                                    <small>
                                                                        Pago em:{' '}
                                                                        {formataDataHoraExibicao(
                                                                            item.dados_faturamento.data_pagamento
                                                                        )}
                                                                    </small>
                                                                </>
                                                            )}
                                                    </td>
                                                    <td>
                                                        {
                                                            item.dados_beneficiario?.nome
                                                        }
                                                    </td>
                                                    <td>
                                                        <a
                                                            href={`/atendimentos/edit/${item.dados_atendimento?.uuid}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            {
                                                                item.dados_atendimento?.atendimento_id
                                                            }
                                                        </a>
                                                    </td>
                                                    <td>
                                                        {
                                                            item.dados_programa?.cliente_nome
                                                        } / 
                                                        {item.dados_programa?.nome}
                                                    </td>
                                                    {/*<td>
                                                        {item.dados_prestador?.nome}
                                                    </td>*/}
                                                    <td>
                                                        {item.dados_servico?.nome}
                                                    </td>
                                                    <td>
                                                        {parseFloat(valor).toLocaleString(
                                                            'pt-BR',
                                                            {
                                                                style: 'currency',
                                                                currency: 'BRL',
                                                            }
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}

                                        <tr className="table-secondary">
                                            <td colSpan={9} align="right">
                                                <strong>Total do Prestador:</strong>
                                            </td>
                                            <td>
                                                <strong>
                                                    {grupo.totalValor.toLocaleString('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL',
                                                    })}
                                                </strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Accordion.Body>
                        </Accordion.Item>
                    );
                })}
            </Accordion>
        );
    };

    filtrarExtrato = (e) => {
        e.preventDefault();

        if (!this.state.filtro_programa_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'É necessário selecionar um programa para filtrar.',
                confirmButtonText: 'OK'
            });
            return;
        }

        this.setState({
            loading: true,
            listSelecionados: []
        })
            
        this.consultaRegistro()
    };

    limparFiltros = () => {
        let startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
        let endOfMonth   = moment().endOf('month').format('YYYY-MM-DD');

        let dados_usuario = getCurrentUser();
        const cliente_id = 13;
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : '';

        this.setState({
            filtro_data_inicio: startOfMonth,
            filtro_data_fim: endOfMonth,
            filtro_cliente_id: cliente_id,
            filtro_programa_id: programa_id,
            filtro_prestador_id: '',
            filtro_nota_fiscal: '',
            listSelecionados: [],
            filtro_doenca_id: '',
            filtro_nota_fiscal: '',
        }, () => {
            this.consultaRegistro()            
        });
    }

    carregarClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})`
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregaProgramas = async (inputValue) => {
        if(!this.state.filtro_cliente_id) {
            return [];
        }

        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${this.state.filtro_cliente_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    carregaPrestadores = async (inputValue) => {
        if(!this.state.filtro_programa_id) {
            return [];
        }

        try {
            const response = await api.get(`/pessoas/prestadores/?programa_id=${this.state.filtro_programa_id}&nome=${inputValue}`);
            const opcoes = response.data.results.map(prestador => ({
                value: prestador.id,
                label: `${prestador.nome} (${prestador.cpf_cnpj} - ${prestador.bairro}, ${prestador.cidade})`
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar prestadores:', error);
            return [];
        }
    };

    handleTogglePago(item) {
        const novoStatusPago = !item.pagamento_servico;

        api.put(`/atendimentos/${item.id}/`, { pagamento_servico: novoStatusPago })
            .then(() => {
                this.consultaRegistro();
            })
            .catch(error => {
                console.error("Erro ao atualizar pagamento:", error);
                // Lógica adicional para tratar o erro, se necessário
            });
    }

    gerarFaturamento = async (prestador_id) => {
        const MySwal = withReactContent(Swal)
        let metodo = 'post'; 
        let url = '/faturamento/';
        const selecionadosGrupo = this.getSelecionadosGrupo(prestador_id);

        this.setState({
            loading: true,
        })

        // Verificar se já existe faturamento em aberto para o prestador
        try {
            const response = await api.get('/faturamento/', {
                params: {
                    programa_id: this.state.filtro_programa_id,
                    laboratorio_id: prestador_id,
                    pago: false,
                    nota_fiscal_status: 'analise',
                    cancelado: false,
                    ultimo_faturamento: true
                }
            });

            if (response.data.results.length > 0) {
                const MySwal = withReactContent(Swal);
                const result = await MySwal.fire({
                    icon: 'question',
                    title: 'Faturamento em Aberto',
                    text: 'Já existe um faturamento em aberto para esse prestador. Deseja inserir esses serviços no mesmo faturamento?',
                    showCancelButton: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                });

                if (result.isConfirmed) {
                    metodo = 'put';
                    url = '/faturamento/' + response.data.results[0].id + '/';
                } 
            }
        } catch (error) {
            console.error('Erro ao verificar faturamentos em aberto:', error);
        }

        api({
            method: metodo,
            url: url,
            data: {
                laboratorio_id: prestador_id,
                programa_id: this.state.filtro_programa_id,
                tipo_faturamento: "servico",
                servicos_cadastro: selecionadosGrupo.join(','),
                insere_servicos: true
            },
        })
        .then(response => {
            const dados = response.data;

            this.setState({
                loading: false,
            })

            Swal.fire({
                title: (metodo == 'post') ? 'Faturamento criado' : 'Faturamento atualizado',
                html: (metodo == 'post') ? 'Faturamento criado com sucesso' : 'Faturamento atualizado com sucesso',
                icon: 'success',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#333333',
                confirmButtonText: 'Ir para o faturamento',
                cancelButtonText: 'Fechar'
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.href = `/faturamentos/edit/${dados.id}`;
                }
            });
        })
        .catch(error => {
            this.setState({
                loading: false,
            })

            // Exibir mensagem de erro sobre criação da sala
            MySwal.fire({
                icon: 'warning',
                title: 'Atenção!',
                html: '<p>Não foi possível gerar o faturamento</p>',
                showCloseButton: true,
            });
        });
    }

    carregaDoencas = async (inputValue) => {
        if(!this.state.filtro_programa_id) {
            return [];
        }

        try {
            const response = await api.get(`/programas/doencas/?programa_id=${this.state.filtro_programa_id}&nome=${inputValue}`);
            const opcoes = response.data.results.map(doenca => ({
                value: doenca.dados_doenca.id,
                label: doenca.dados_doenca.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar doenças:', error);
            return [];
        }
    };

    agruparPorPrestador = (itens) => {
        return itens.reduce((acc, item) => {
            const prestadorId = item.dados_prestador.id;

            // Ignora itens sem prestadorId
            if (!prestadorId) return acc;

            if (!acc[prestadorId]) {
                acc[prestadorId] = {
                    prestador: item.dados_prestador, // { id, nome }
                    itens: [],
                    totalValor: 0,
                };
            }

            acc[prestadorId].itens.push(item);

            // garante número, mesmo que venha string "1550.00"
            const valorNumero = parseFloat(item.valor || 0);
            if (!isNaN(valorNumero)) {
                acc[prestadorId].totalValor += valorNumero;
            }

            return acc;
        }, {});
    }

    render() {
        if (!hasPerm('view_agendamentos')) {
            return <Navigate to='/sem-permissao' />
        }

        let dados_usuario = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Extrato Financeiro</h4>
                    </Col>                    
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                                            
                        <h4>Filtros</h4>
                        <Form method="get" onSubmit={this.filtrarExtrato}>
                            <Row>
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data Início</Form.Label>
                                        <Form.Control type="date" name="filtro_data_inicio" value={this.state.filtro_data_inicio} onChange={e => this.handleChangeFiltros(e, 'filtro_data_inicio')} />    
                                    </Form.Group>
                                </Col>
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data Final</Form.Label>
                                        <Form.Control type="date" name="filtro_data_fim" value={this.state.filtro_data_fim} onChange={e => this.handleChangeFiltros(e, 'filtro_data_fim')} />    
                                    </Form.Group>
                                </Col>
                                <Col sm={2} xs={12} className="d-none">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Com Nota Fiscal?</Form.Label>
                                        <div>
                                            <Button 
                                                variant={this.state.filtro_nota_fiscal == "1" ? "success" : "outline-secondary"}
                                                onClick={() => (this.state.filtro_nota_fiscal == "1") ? this.setState({ filtro_nota_fiscal: '' }) : this.setState({ filtro_nota_fiscal: "1" })}>
                                                Sim
                                            </Button>
                                            {/*' '}
                                            <Button 
                                                variant={this.state.filtro_nota_fiscal == "0" ? "danger" : "outline-secondary"}
                                                onClick={() => (this.state.filtro_nota_fiscal == "0") ? this.setState({ filtro_nota_fiscal: '' }) : this.setState({ filtro_nota_fiscal: "0" })}>
                                                Não
                                            </Button>*/}
                                        </div>
                                    </Form.Group>
                                </Col>
                                {dados_usuario['ambiente_cliente_id'] === "" && (
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Cliente</Form.Label>
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={this.carregarClientes}
                                            defaultOptions
                                            name="cliente_id"
                                            placeholder="Buscar cliente..."
                                            noOptionsMessage={() => "Nenhum cliente encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'cliente_id')}
                                            value={this.state.filtro_cliente_id ? { value: this.state.filtro_cliente_id, label: this.state.filtro_cliente_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                )}
                                {this.state.filtro_cliente_id && dados_usuario['ambiente_programa_id'] === "" && (
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programa</Form.Label>
                                        <AsyncSelect          
                                            key={this.state.programa_select_key}                                  
                                            cacheOptions
                                            loadOptions={this.carregaProgramas}
                                            defaultOptions
                                            name="programa_id"
                                            placeholder={'Buscar programa...'}
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                            value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                )}
                                {this.state.filtro_programa_id && (
                                <Col sm={6} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Prestador</Form.Label>
                                        <AsyncSelect                                  
                                            key={this.state.prestador_select_key}                
                                            cacheOptions
                                            loadOptions={this.carregaPrestadores}
                                            defaultOptions
                                            name="prestador_id"
                                            placeholder='Selecionar prestador...'
                                            noOptionsMessage={() => "Nenhum resultado encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'prestador_id')}
                                            value={this.state.filtro_prestador_id ? { value: this.state.filtro_prestador_id, label: this.state.filtro_prestador_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                )}
                                {this.state.filtro_programa_id && (
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Patologia</Form.Label>
                                        <AsyncSelect                                  
                                            key={this.state.doenca_select_key}                
                                            cacheOptions
                                            loadOptions={this.carregaDoencas}
                                            defaultOptions
                                            name="doenca_id"
                                            placeholder='Selecionar patologia...'
                                            noOptionsMessage={() => "Nenhuma patologia encontrada"}
                                            onChange={e => this.handleChangeFiltros(e, 'doenca_id')}
                                            value={this.state.filtro_doenca_id ? { value: this.state.filtro_doenca_id, label: this.state.filtro_doenca_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                )}                                
                            </Row>
                            <Row>
                                <Col sm={3} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Check 
                                            type="checkbox"
                                            id="a_faturar"
                                            label="Somente serviços a faturar"
                                            value="1"
                                            checked={this.state.filtro_a_faturar ? true : false} 
                                            onChange={e => this.handleChangeFiltros(e, 'a_faturar')}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            
                            <Button type="submit" variant="secondary" size="sm">
                                {
                                this.state.loading ? 
                                <span className="spinner-border spinner-border-sm"></span> 
                                : 
                                <>
                                    <FaSearch /> Filtrar
                                </>
                                }      
                            </Button>
                            
                            <Button type="button" size="sm" variant="light" className="ms-2" onClick={() => this.limparFiltros()}>
                                <FaEraser /> Limpar filtro
                            </Button>
                        </Form>                                                                                                         
                    </Card.Body>                
                </Card>

                <div>
                    {this.renderRows()}   
                </div> 

                <Modal show={this.state.showModal} onHide={this.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Nota Fiscal</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Data da Nota Fiscal: {formataDataHoraExibicao(this.state.modalData)}</p>
                        <p>
                            <a href={this.state.modalLink} target="_blank" rel="noopener noreferrer">
                                Baixar Nota Fiscal
                            </a>
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.closeModal}>
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default withRouter(ExtratoServicos);
